/* eslint complexity: ["error", 40] */

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';
import {Button, Container, Dropdown, DropdownButton, Fade, Form, Tabs, Tab} from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import {push} from 'connected-react-router';
import {Formik} from 'formik';
import DatePicker from 'react-datepicker';
import queryString from 'query-string';
import CommonMetaTag from './common-meta-tag';
import coming_soon from '../images/video_store_coming_soon.png';
import defaultFieldImage from '../images/default_field_image.png'
import {useTranslation} from 'react-i18next';
import Configuration from '../config';
import {getVideosStorePartner, addVideoToPartnerArea, requestVideo} from '../actions/partner';
import {FaCalendarAlt, FaClock, FaCopy, FaHdd, FaMapMarkerAlt, FaPlayCircle, FaSearch, FaSyncAlt, FaVideo} from 'react-icons/fa';

const PartnerVideoStore = ({
  token,
  profile,
  videosStore,
  videosStoreSoon,
  addVideoToPartnerArea,
  requestVideo,
  ownedFields,
  ownedServices,
  searchVideos,
  location: {search}
}) => {
  const {t} = useTranslation();
  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  const params = queryString.parse(search);

  const setValueForField = (f, id) => {
    f('fieldId', id);
    f('serviceId', null);
  };

  const setValueForService = (f, id) => {
    f('fieldId', null);
    f('serviceId', id);
  };

  const getFieldImage = (partnerId, fieldId, fieldImage) => {
    return `${Configuration.apiEndPoint}/partners/fields/${fieldId}/images?load=${fieldImage}`
  }

  let dialog = null;
  const videoScheduled = () => () => {
    dialog.show({
      title: t('VIDEO_SCHEDULED_TITLE'),
      body: t('VIDEO_SCHEDULED_INFO'),
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear', minHeight: 1000}}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter dashboard_hero_rp" data-parallax="true">
            <div className="dashboard_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp">
            <div className="section">
              <div className="container">
                <div className="row mb-4">
                  <div className="col-12">
                    <div className="skywork-store-panel">
                      <div className="skywork-store-panel-copy">
                        <h4 className="section_title_neg_rp">{t('VIDEO_STORE') + " " + t('REPLAYER_VIDEOS')}</h4>
                        <p>{t('CHOOSE_VIDEO_PARTNER')}</p>
                      </div>
                      <div className="skywork-store-filter-panel">
                        <Formik
                          enableReinitialize
                          initialValues={{fieldId: params.fieldId ? Number(params.fieldId) : null, serviceId: params.serviceId ? Number(params.serviceId) : null, fromDatetime: params.fromDatetime ? new Date(params.fromDatetime).toISOString() : null, toDatetime: params.toDatetime ? new Date(params.toDatetime).toISOString() : null}}
                          onSubmit={searchVideos}
                        >
                          {({
                            handleSubmit,
                            handleChange,
                            setFieldValue,
                            values
                          }) => {
                            return (
                              <Form className="skywork-store-filter-form" onSubmit={handleSubmit}>
                                <div className="skywork-store-filter-field skywork-store-filter-field--venue">
                                  <label>{t('FIELD_GYM_POOL')}</label>
                                  <DropdownButton className="video_store_dropdown" title={values.fieldId === null && values.serviceId === null? t('SELECT') : values.serviceId === null ? ownedFields.find(sf => sf.id === values.fieldId).name : ownedServices.find(ss => ss.id === values.serviceId).name}>
                                    {
                                      ownedFields.map(f => (
                                        f.recording?
                                        <Dropdown.Item key={f.id} href="#" onClick={() => setValueForField(setFieldValue, f.id)}>{f.name}</Dropdown.Item>
                                        :null
                                      ))
                                    }
                                    {
                                      ownedServices.map(s => (
                                        s.recording?
                                        <Dropdown.Item key={s.id} href="#" onClick={() => setValueForService(setFieldValue, s.id)}>{s.name}</Dropdown.Item>
                                        :null
                                      ))
                                    }
                                  </DropdownButton>
                                </div>
                                <div className="skywork-store-filter-field">
                                  <label>{t('PERIOD')}</label>
                                  <Form.Group>
                                  <DatePicker
                                    showTimeSelect
                                    locale="it"
                                    className="form-control"
                                    timeFormat="HH:mm"
                                    dateFormat="dd/MM/yyyy HH:mm"
                                    dropdownMode="select"
                                    selected={(values.fromDatetime && new Date(values.fromDatetime)) || null}
                                    onChange={val => setFieldValue('fromDatetime', val ? val.toISOString() : val)}/>
                                  </Form.Group>
                                </div>
                                <div className="skywork-store-filter-field skywork-store-filter-field--end">
                                  <label>{t('PERIOD')}</label>
                                  <Form.Group>
                                  <DatePicker
                                    showTimeSelect
                                    locale="it"
                                    className="form-control"
                                    timeFormat="HH:mm"
                                    dateFormat="dd/MM/yyyy HH:mm"
                                    dropdownMode="select"
                                    minTime={new Date().setHours(0,30)}
                                    maxTime={new Date().setHours(23,59)}
                                    selected={(values.toDatetime && (new Date(values.toDatetime).getHours() === 0 && new Date(values.toDatetime).getMinutes() === 0 ? new Date(values.toDatetime).setHours(23,59) : new Date(values.toDatetime))) || null}
                                    onChange={val => setFieldValue('toDatetime', val ? val.getHours() === 0 && val.getMinutes() === 0 ? new Date(val.setHours(23,59)).toISOString() : val.toISOString() : val)}/>
                                  </Form.Group>
                                </div>
                                <div className="skywork-store-filter-actions">
                                  <button type="submit" className="btn myvideo-action myvideo-action--primary"><FaSearch aria-hidden="true"/>{t('FIND')}</button>
                                  <Button
                                    type="button"
                                    className="btn myvideo-action myvideo-action--utility"
                                    onClick={() => searchVideos({fieldId: values.fieldId ? Number(values.fieldId) : null, serviceId: values.serviceId ? Number(values.serviceId) : null, fromDatetime: values.fromDatetime ? new Date(values.fromDatetime).toISOString() : null, toDatetime: values.toDatetime ? new Date(values.toDatetime).toISOString() : null})}
                                    >
                                    <FaSyncAlt aria-hidden="true"/>{t('UPDATE_VIDEOS')}
                                  </Button>
                                </div>
                              </Form>
                            );
                          }}
                        </Formik>
                      </div>
                    </div>
                    <Tabs defaultActiveKey="watch_now" className="videostore-tabs myvideo-section-tabs partner-video-store-tabs" style={{marginTop: 20}}>
                      <Tab eventKey="watch_now" title={<span><FaPlayCircle aria-hidden="true"/>{t('WATCH_NOW')}</span>} tabClassName="videostore-tab">
                        <div className="row">
                          {
                            videosStore && videosStore.length > 0 ?
                              videosStore.map(v => (
                                <div key={v.id} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                  <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--store">
                                    <div>
                                      <img src={new Date(v.timestamp) > new Date() ? coming_soon: v.fieldId && v.fieldImage && v.partnerId ? getFieldImage(v.partnerId, v.fieldId, v.fieldImage) : defaultFieldImage} alt={t('VIDEO_STORE')} style={{width: '100%', height: '100%'}}/>
                                    </div>
                                    <div className="card-body d-flex flex-column card_border_bottom_white skywork-store-card-body">
                                      <div className="skywork-video-card-title-box"><h5 className="card-title">{v.description}</h5></div>
                                      <div className="skywork-store-card-info-grid">
                                        <div className="skywork-store-card-info-box"><span><FaCalendarAlt aria-hidden="true"/>{t('PERIOD')}</span><strong>{new Date(v.timestamp).toLocaleDateString()}</strong><small><FaClock aria-hidden="true"/>{new Date(v.timestamp).toTimeString().slice(0, 5)}</small></div>
                                        <div className="skywork-store-card-info-box"><span><FaMapMarkerAlt aria-hidden="true"/>{t('FIELD_GYM_POOL')}</span><strong>{v.fieldName}</strong></div>
                                      </div>
                                      {
                                        v.event ?
                                          <div className="video_store_card_event_icon"/> :
                                          v.reserved ?
                                            <div className="video_store_card_club_icon"/> :
                                            <div className="video_store_card_player_icon"/>
                                      }
                                      <div className="skywork-store-card-metrics">
                                        <span><FaClock aria-hidden="true"/><strong>{t('DURATION')}</strong>{new Date(v.duration * 1000).toISOString().slice(11, 19)}</span>
                                        {v.filesize ? <span><FaHdd aria-hidden="true"/><strong>{t('FILE_SIZE')}</strong>{(Math.floor(v.filesize)/(1000000000)).toFixed(2)}GB</span> : null}
                                      </div>
                                    </div>
                                    <div className="skywork-store-card-actions">
                                      {v.videoReady ?
                                        <button type="button" data-toggle="modal" className="btn myvideo-action myvideo-action--primary" onClick={addVideoToPartnerArea(v.id)}><FaCopy aria-hidden="true"/>{t('COPY_TO_MY_VIDEO')}</button>
                                      : v.videoBought?
                                        <button type="button" data-toggle="modal" className="btn myvideo-action myvideo-action--utility"><FaVideo aria-hidden="true"/>{t('VIDEO_IN_PROGRESS')}</button>
                                      : <button type="button" data-toggle="modal" className="btn myvideo-action myvideo-action--utility" onClick={requestVideo(v.id)}><FaVideo aria-hidden="true"/>{t('REQUEST_VIDEO')}</button>}
                                    </div>
                                  </div>
                                </div>
                              ))
                            : <Fragment>
                                  <div className="col-lg-12 mt-sm-2 text-center" style={{background: '#00152f50', paddingTop: 15}}>
                                    <p><h5>{t('NO_VIDEO')}</h5></p>
                                  </div>
                              </Fragment>
                          }
                        </div>
                      </Tab>
                      <Tab eventKey="soon" title={<span><FaClock aria-hidden="true"/>{t('SOON')}</span>} tabClassName="videostore-tab">
                      <div className="row">
                          {
                            videosStoreSoon && videosStoreSoon.length > 0 ?
                              videosStoreSoon.map(v => (
                                <div key={v.id} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                  <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--store-soon">
                                    <div>
                                      <img src={new Date(v.timestamp) > new Date() ? coming_soon: v.fieldId && v.fieldImage && v.partnerId ? getFieldImage(v.partnerId, v.fieldId, v.fieldImage) : defaultFieldImage} alt={t('VIDEO_STORE')} style={{width: '100%', height: '100%'}}/>
                                    </div>
                                    <div className="card-body d-flex flex-column card_border_bottom_white skywork-store-card-body">
                                      <div className="skywork-video-card-title-box"><h5 className="card-title">{v.description}</h5></div>
                                      <div className="skywork-store-card-info-grid">
                                        <div className="skywork-store-card-info-box"><span><FaCalendarAlt aria-hidden="true"/>{t('PERIOD')}</span><strong>{new Date(v.timestamp).toLocaleDateString()}</strong><small><FaClock aria-hidden="true"/>{new Date(v.timestamp).toTimeString().slice(0, 5)}</small></div>
                                        <div className="skywork-store-card-info-box"><span><FaMapMarkerAlt aria-hidden="true"/>{t('FIELD_GYM_POOL')}</span><strong>{v.fieldName}</strong></div>
                                      </div>
                                      {
                                        v.event ?
                                          <div className="video_store_card_event_icon"/> :
                                          v.reserved ?
                                            <div className="video_store_card_club_icon"/> :
                                            <div className="video_store_card_player_icon"/>
                                      }
                                      <div className="skywork-store-card-metrics"><span><FaClock aria-hidden="true"/><strong>{t('DURATION')}</strong>{new Date(v.duration * 1000).toISOString().slice(11, 19)}</span></div>
                                    </div>
                                    <div className="skywork-store-card-actions">
                                      <button type="button" className="btn myvideo-action myvideo-action--utility" onClick={videoScheduled()}><FaClock aria-hidden="true"/>{t('VIDEO_SCHEDULED')}</button>
                                    </div>
                                  </div>
                                </div>
                              ))
                            : <Fragment>
                                  <div className="col-lg-12 mt-sm-2 text-center" style={{background: '#00152f50', paddingTop: 15}}>
                                    <p><h5>{t('NO_VIDEO_SOON')}</h5></p>
                                  </div>
                              </Fragment>
                          }
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Fade>
      <Dialog
        ref={el => {
          dialog = el;
        }}/>
    </Fragment>
  );
};

PartnerVideoStore.propTypes = {
  token: PropTypes.string,
  profile: PropTypes.object.isRequired,
  goto: PropTypes.func.isRequired,
  videosStore: PropTypes.array,
  videosStoreSoon: PropTypes.array,
  addVideoToPartnerArea: PropTypes.func.isRequired,
  ownedFields: PropTypes.array,
  ownedServices: PropTypes.array,
  searchVideos: PropTypes.func.isRequired,
  purchaseVideo: PropTypes.func.isRequired,
  rtvVideos: PropTypes.array,
  video: PropTypes.array,
  permanentVideos: PropTypes.array
};

PartnerVideoStore.defaultProps = {
  token: null,
  videosStore: [],
  videosStoreSoon: [],
  ownedFields: [],
  ownedServices: [],
  video: [],
  permanentVideos: [],
  rtvVideos: []
};

const mapStateToProps = ({login: {token, profile}, partner: {ownedFields, ownedServices, videosStore, videosStoreSoon}}) => ({
  token,
  profile,
  videosStore,
  videosStoreSoon,
  ownedFields,
  ownedServices,
});

const mapDispatchToProps = dispatch => ({
  addVideoToPartnerArea: slotId => () => {
    dispatch(addVideoToPartnerArea(slotId));
    dispatch(push('/partner-video'));
  },
  searchVideos: filters => {
    dispatch(getVideosStorePartner(filters.fieldId, filters.serviceId, filters.fromDatetime, filters.toDatetime));
  },
  requestVideo: slotId => () => {
    dispatch(requestVideo(slotId));
  },
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerVideoStore));
